import { makeStyles, TableRow } from '@material-ui/core'
import React from 'react'
import { FullFormatOptions } from '../../util/formatters'
import { NO_MATCHING_RESOURCE_SYMBOL } from './constants'
import { TableTitleCell } from './TableTitleCell'
import { TableValueCell } from './TableValueCell'

type Props = {
  title: string
  values: (number | null)[]
  formatter: (value: number, options: FullFormatOptions) => string
  highlight?: boolean
  hide?: boolean
  hideIfValuesIrrelevant?: boolean
}

const useStyles = makeStyles(() => ({
  hiddenRow: {
    display: 'none',
  },
}))

export function ResultsTableRow(props: Props): React.ReactElement {
  const { title, values, formatter, highlight, hide, hideIfValuesIrrelevant } =
    props
  const classes = useStyles()

  const hideByRelevancy =
    hideIfValuesIrrelevant && !values.some((value) => value && value > 0)

  const formatValue = (value: number | null) =>
    value === null
      ? NO_MATCHING_RESOURCE_SYMBOL
      : formatter(value, { omitUnit: true })

  return (
    <TableRow className={hide || hideByRelevancy ? classes.hiddenRow : ''}>
      <TableTitleCell title={title} highlight={highlight} />
      {values.map((value, index) => (
        <TableValueCell
          key={`results-${formatValue(value)}-${index.toString()}`}
          value={formatValue(value)}
          highlight={highlight}
        />
      ))}
    </TableRow>
  )
}
